export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [{
    // 内部采购企业-POC订单管理-POC无协议订单管理-POC我的订单
    path: 'pocUnagrMyOrder',
    name: 'pocUnagrMyOrder',
    meta: {
      title: '我的订单',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrMyOrder/pocUnagrMyOrder.vue');
    }
  }, {
    // 内部采购企业-POC订单管理-POC无协议订单管理-POC我的取消申请
    path: 'pocUnagrMyCancleApply',
    name: 'pocUnagrMyCancleApply',
    meta: {
      title: '我的取消申请',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrMyCancleApply/pocUnagrMyCancleApply.vue');
    }
  }, {
    // 内部采购企业-POC订单管理-POC无协议订单管理-POC订单审批
    path: 'pocUnagrApprovalOrder',
    name: 'pocUnagrApprovalOrder',
    meta: {
      title: '订单审批',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrApprovalOrder/pocUnagrApprovalOrder.vue');
    }
  }, {
    // 内部采购企业-POC订单管理-POC无协议订单管理-POC到货验收
    path: 'pocUnagrArrivalAcceptance',
    name: 'pocUnagrArrivalAcceptance',
    meta: {
      title: '到货验收',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrArrivalAcceptance/pocUnagrArrivalAcceptance.vue');
    }
  }, {
    // 内部采购企业-POC订单管理-POC无协议订单管理-POC采购订单管理
    path: 'pocUnagrMyPurchaseOrder',
    name: 'pocUnagrMyPurchaseOrder',
    meta: {
      title: '采购订单管理',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrMyPurchaseOrder/pocUnagrMyPurchaseOrder.vue');
    }
  }, {
    // 内部采购企业-POC订单管理-POC无协议订单管理-POC订单异常变更确认
    path: 'pocUnagrExceptionConfirmOrder',
    name: 'pocUnagrExceptionConfirmOrder',
    meta: {
      title: '订单异常变更确认',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrExceptionConfirmOrder/pocUnagrExceptionConfirmOrder.vue');
    }
  }, {
    // 内部采购企业-POC订单管理-POC商城订单管理-POC我的商城订单
    path: 'pocMyShopOrder',
    name: 'pocMyShopOrder',
    meta: {
      title: '我的商城订单',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocShopOrderMenu/pocMyShopOrder/pocMyShopOrder.vue');
    }
  }, {
    // 内部采购企业-POC订单管理-POC商城订单管理-POC待处理订单管理
    path: 'pocShopPendingOrder',
    name: 'pocShopPendingOrder',
    meta: {
      title: '待处理订单管理',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocShopOrderMenu/pocShopPendingOrder/pocShopPendingOrder.vue');
    }
  }, {
    // 订单收银台
    path: 'pocOrderPayMent',
    name: 'pocOrderPayMent',
    meta: {
      title: '支付方式选择',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/components/pocOrderPayMent.vue');
    }
  }, {
    // 订单收银台
    path: 'pocOrderDetail',
    name: 'pocOrderDetail',
    meta: {
      title: '订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderMenu/pocOrderDetail.vue');
    }
  }, // 内部采购企业-POC订单管理-POC电商订单管理-POC收发货详情
  {
    path: 'pocReceivingAddressDetail',
    name: 'pocReceivingAddressDetail',
    meta: {
      title: '收发货详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderMenu/pocReceivingAddressDetail.vue');
    }
  }, // 内部采购企业-POC订单管理-POC电商订单管理-POC售后管理
  {
    path: 'pocEcAfterSalesManagement',
    name: 'pocEcAfterSalesManagement',
    meta: {
      title: '售后管理',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderMenu/pocEcAfterSalesManagement/pocEcAfterSalesManagement.vue');
    }
  }, // 内部采购企业-POC订单管理-POC电商订单统计查询-POC售后详情
  {
    path: 'pocEcAfterSalesSearchDetail',
    name: 'pocEcAfterSalesSearchDetail',
    meta: {
      title: '售后详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderCountMenu/pocEcAfterSalesSearch/pocEcAfterSalesSearchDetail.vue');
    }
  }, // 内部采购企业-POC订单管理-POC电商订单管理-POC维护发运信息
  {
    path: 'pocEcMaintainShipInfoDetail',
    name: 'pocEcMaintainShipInfoDetail',
    meta: {
      title: '维护发运信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderMenu/pocEcAfterSalesManagement/pocEcMaintainShipInfoDetail.vue');
    }
  }, // 内部采购企业-POC订单管理-POC电商订单管理-POC售后申请列表
  {
    path: 'pocEcAfterSalesApplication',
    name: 'pocEcAfterSalesApplication',
    meta: {
      title: '售后申请列表',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderMenu/pocEcAfterSalesApplication/pocEcAfterSalesApplication.vue');
    }
  }, // 内部采购企业-POC订单管理-POC协议订单管理-POC订单详情
  {
    path: 'pocAgrOrderDetail',
    name: 'pocAgrOrderDetail',
    meta: {
      title: '订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocAgrOrderMenu/pocAgrOrderDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单管理-收发货
    path: 'pocUnagrReceivingAddressDetail',
    name: 'pocUnagrReceivingAddressDetail',
    meta: {
      title: '收发货详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrReceivingAddressDetail.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-售后申请列
  {
    path: 'pocEcAfterSalesSubmit',
    name: 'pocEcAfterSalesSubmit',
    meta: {
      title: '售后申请提交',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderMenu/pocEcAfterSalesApplication/pocEcAfterSalesSubmit.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的订单-到货确认/拒收
  {
    path: 'pocAgrArrivalConfirmation',
    name: 'pocAgrArrivalConfirmation',
    meta: {
      title: '到货确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocAgrOrderMenu/pocAgrMyOrder/pocAgrArrivalConfirmation.vue');
    }
  }, // 运营管理-订单管理-评价管理-查看评价详情
  {
    path: 'pocEvaluationOrderDetail',
    name: 'pocEvaluationOrderDetail',
    meta: {
      title: '查看评价详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEvaluateMenu/pocEvaluationOrderDetail.vue');
    }
  }, // 运营管理-机构及用户管理 - 个人用户管理
  {
    path: 'individualUser',
    name: 'individualUser',
    meta: {
      title: '个人用户管理'
    },
    component: function component() {
      return import('@/pages/pocOrderModule/organizationMenu/individualUser.vue');
    }
  }, {
    // 协议评价
    path: 'pocAgEvaluate',
    name: 'pocAgEvaluate',
    meta: {
      title: '评价',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEvaluateMenu/pocAgEvaluate.vue');
    }
  }, // 内部采购企业-订单管理-电商订单统计查询-订单异常变更查询
  {
    path: 'pocEcExceptionChangeOrder',
    name: 'pocEcExceptionChangeOrder',
    meta: {
      title: '订单异常变更查询',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderCountMenu/pocEcExceptionChangeOrder/pocEcExceptionChangeOrder.vue');
    }
  }, // 内部采购企业-订单管理-电商订单统计查询-订单异常变更详情
  {
    path: 'pocEcExceptionStatusCountChangeDetail',
    name: 'pocEcExceptionStatusCountChangeDetail',
    meta: {
      title: '订单异常变更详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderCountMenu/pocEcExceptionChangeOrder/pocEcExceptionStatusCountChangeDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单统计查询-订单调价详情
  {
    path: 'pocAgrAdjustmentQueryDetail',
    name: 'pocAgrAdjustmentQueryDetail',
    meta: {
      title: '订单调价详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocAgrOrderCountMenu/pocAgrAdjustmentQuery/pocAgrAdjustmentQueryDetail.vue');
    }
  }, // 内部采购企业-订单管理-电商订单管理-订单审批-单个订单审批
  {
    path: 'pocEcApprovalOrderDetail',
    name: 'pocEcApprovalOrderDetail',
    meta: {
      title: '订单审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderMenu/pocEcApprovalOrder/pocEcApprovalOrderDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-复核订单
  {
    path: 'pocAgrReviewOrder',
    name: 'pocAgrReviewOrder',
    meta: {
      title: '复核订单',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocAgrOrderMenu/pocAgrReviewCheckOrder/pocAgrReviewOrder.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的贸易销售订单-调价核实
  {
    path: 'pocAgrAdjustVerification',
    name: 'pocAgrAdjustVerification',
    meta: {
      title: '调价核实',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocAgrOrderMenu/pocAgrTradeSalesOrder/pocAgrAdjustVerification.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的三方交易销售订单-调价核实
  {
    path: 'pocAgrBusAdjustConfirm',
    name: 'pocAgrBusAdjustConfirm',
    meta: {
      title: '调价核实',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocAgrOrderMenu/pocAgrMyMatchingSalesOrder/pocAgrBusAdjustConfirm.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-调价核实
  {
    path: 'pocAgrAdjustConfirm',
    name: 'pocAgrAdjustConfirm',
    meta: {
      title: '调价核实',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocAgrOrderMenu/pocAgrMyPendingOrders/pocAgrAdjustConfirm.vue');
    }
  }, // 运营管理-订单管理-电商订单统计查询-销售订单详情
  {
    path: 'pocEcSalesOrderQueryDetail',
    name: 'pocEcSalesOrderQueryDetail',
    meta: {
      title: '销售订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderCountMenu/pocEcSalesOrderQuery/pocEcSalesOrderQueryDetail.vue');
    }
  }, // 运营管理-订单管理-电商订单统计查询-采购订单详情
  {
    path: 'pocEcPurchaseOrderQueryDetail',
    name: 'pocEcPurchaseOrderQueryDetail',
    meta: {
      title: '采购订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderCountMenu/pocEcPurchaseOrderQuery/pocEcPurchaseOrderQueryDetail.vue');
    }
  }, // 运营管理-订单管理-电商订单统计查询-三方交易模式订单详情
  {
    path: 'pocEcMatchingOrderQueryDetail',
    name: 'pocEcMatchingOrderQueryDetail',
    meta: {
      title: '三方交易模式订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocEcOrderCountMenu/pocEcMatchingOrderQuery/pocEcMatchingOrderQueryDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-取消申请详情
  {
    path: 'pocAgrCancleOrderDetail',
    name: 'pocAgrCancleOrderDetail',
    meta: {
      title: '取消申请详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocAgrOrderMenu/pocAgrMyCancleApply/pocAgrCancleOrderDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-查看收发货详情
  {
    path: 'pocAgrReceivingAddressDetail',
    name: 'pocAgrReceivingAddressDetail',
    meta: {
      title: '收发货详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocAgrOrderMenu/pocAgrReceivingAddressDetail.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-我的订单-到货验收
  {
    path: 'pocAgrConfirmReciving',
    name: 'pocAgrConfirmReciving',
    meta: {
      title: '到货验收',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocAgrOrderMenu/pocAgrMyOrder/pocAgrConfirmReciving.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单管理-订单详情
    path: 'pocUnagrOrderDetail',
    name: 'pocUnagrOrderDetail',
    meta: {
      title: '订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrOrderDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-服务单详情
    path: 'pocUnagrViewServiceDetail',
    name: 'pocUnagrViewServiceDetail',
    meta: {
      title: '服务单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrAfterSalesManagement/pocUnagrViewServiceDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-售后管理
    path: 'pocUnagrAfterSalesSubmit',
    name: 'pocUnagrAfterSalesSubmit',
    meta: {
      title: '售后申请提交',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrAfterSalesManagement/pocUnagrAfterSalesSubmit.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-到货确认
    path: 'pocUnagrArrivalConfirmation',
    name: 'pocUnagrArrivalConfirmation',
    meta: {
      title: '到货确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrMyOrder/pocUnagrArrivalConfirmation.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-售后管理
    path: 'pocUnagrAfterSalesManagement',
    name: 'pocUnagrAfterSalesManagement',
    meta: {
      title: '售后管理',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrAfterSalesManagement/pocUnagrAfterSalesManagement.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-售后管理
    path: 'pocUnagrExceptionOrder',
    name: 'pocUnagrExceptionOrder',
    meta: {
      title: '订单异常变更',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrExceptionOrder/pocUnagrExceptionOrder.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-数量变更发起
    path: 'pocUnagrExceptionOrderChange',
    name: 'pocUnagrExceptionOrderChange',
    meta: {
      title: '数量变更发起',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrExceptionOrder/pocUnagrExceptionOrderChange.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-到货验收
    path: 'pocUnagrConfirmReciving',
    name: 'pocUnagrConfirmReciving',
    meta: {
      title: '到货验收',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrMyOrder/pocUnagrConfirmReciving.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-订单审批提交
    path: 'pocUnagrApprovalOrderDetail',
    name: 'pocUnagrApprovalOrderDetail',
    meta: {
      title: '订单审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrApprovalOrder/pocUnagrApprovalOrderDetail.vue');
    }
  }, {
    // 供方订单详情
    path: 'pocSupplierOrderDetails',
    name: 'pocSupplierOrderDetails',
    meta: {
      title: '订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/components/pocSupplierOrderDetails.vue');
    }
  }, // 内部采购企业-订单管理-协议订单管理-订单详情
  {
    path: 'pocPurAgrOrderDetail',
    name: 'pocPurAgrOrderDetail',
    meta: {
      title: '订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocAgrOrderMenu/pocPurAgrOrderDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单管理-订单详情
    path: 'pocUnpurAgrOrderDetail',
    name: 'pocUnpurAgrOrderDetail',
    meta: {
      title: '订单详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnpurAgrOrderDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-商城订单管理-我的商城订单-我的商城订单列表-发货
    path: 'pocDeliverGoods',
    name: 'pocDeliverGoods',
    meta: {
      title: '发货',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocShopOrderMenu/pocMyShopOrder/pocDeliverGoods.vue');
    }
  }, {
    // 内部采购企业-订单管理-商城订单管理-我的商城订单-我的商城订单列表-发货
    path: 'pocArrivalRegistration',
    name: 'pocArrivalRegistration',
    meta: {
      title: '到货登记',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocShopOrderMenu/pocMyShopOrder/pocArrivalRegistration.vue');
    }
  }, {
    // 内部采购企业-订单管理-ZMY-无协议订单管理-我的取消申请-取消申请详情
    path: 'pocUnagrCancleOrderDetail',
    name: 'pocUnagrCancleOrderDetail',
    meta: {
      title: '取消申请详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderMenu/pocUnagrMyCancleApply/pocUnagrCancleOrderDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-商城订单管理-待处理订单管理 / 待确认取消订单申请-申请单确认
    path: 'pocApplicationFormConfirm',
    name: 'pocApplicationFormConfirm',
    meta: {
      title: '申请单确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocShopOrderMenu/pocShopPendingOrder/pocApplicationFormConfirm.vue');
    }
  }, {
    // 内部采购企业-订单管理-商城订单管理-待处理订单管理 / 待确认取消订单申请-售后申请确认
    path: 'pocAfterSalesApplyConfirm',
    name: 'pocAfterSalesApplyConfirm',
    meta: {
      title: '售后申请确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocShopOrderMenu/pocShopPendingOrder/pocAfterSalesApplyConfirm.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单统计查询-订单异常变更查询-订单异常变更详情
    path: 'pocUnagrExceptionOrderQueryDetail',
    name: 'pocUnagrExceptionOrderQueryDetail',
    meta: {
      title: '订单异常变更详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderCountMenu/pocUnagrExceptionOrderQuery/pocUnagrExceptionOrderQueryDetail.vue');
    }
  }, {
    // 内部采购企业-订单管理-无协议订单统计查询-订单异常变更查询 / 订单异常变更查询
    path: 'pocUnagrExceptionOrderQuery',
    name: 'pocUnagrExceptionOrderQuery',
    meta: {
      title: '订单异常变更查询',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocUnagrOrderCountMenu/pocUnagrExceptionOrderQuery/pocUnagrExceptionOrderQuery.vue');
    }
  }, {
    // 内部采购企业-订单管理-POC待办管理-POC订单待办事项
    path: 'pocOrderTodoTaskSchedule',
    name: 'pocOrderTodoTaskSchedule',
    meta: {
      title: 'POC订单待办事项',
      cache: true
    },
    component: function component() {
      return import('@/pages/pocOrderModule/pocTodoTaskMenu/pocOrderTodoTaskManage/pocOrderTodoTaskSchedule.vue');
    }
  }]
};